import { FC, useState, FormEvent, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { PopupType, openAuthPopup } from '../../store/auth';
import { Container, InputText, Button, Spacing, Text } from '../ui';
import { RootState } from '../../store';
import axios from 'axios';
import { useMutation } from 'react-query';

const forgotPassword = async (email: string) => {
  const response = await axios.post('/forgot-password', { email });
  return response;
};

const ForgotPassword: FC = () => {
  const { isPopupOpen, popupType } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState('');
  const { mutateAsync: forgotPasswordMutation } = useMutation(forgotPassword);
  const [email, setEmail] = useState('');

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMessage('');
    try {
      await forgotPasswordMutation(email);
      dispatch(openAuthPopup(PopupType.Reset_Instructions));
      setEmail('');
    } catch (error) {
      setErrorMessage(error.response.data);
    }
  };

  useEffect(() => {
    if (isPopupOpen) {
      setErrorMessage('');
    }

    return () => {
      setErrorMessage('');
      setEmail('');
    };
  }, [popupType, isPopupOpen]);

  return (
    <Container paddingHorizontal="none">
      <form onSubmit={onSubmit}>
        <InputText name="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <Spacing bottom="xs" />
        {errorMessage && (
          <Spacing top="sm">
            <Text color="error">{errorMessage}</Text>
          </Spacing>
        )}
        <Spacing bottom="sm" />
        <Button color="primary" fullWidth>
          Reset password
        </Button>
      </form>
    </Container>
  );
};

export default ForgotPassword;
